import React from "react";
import SyncIcon from "../../../assets/sync-icon.svg";

interface HeadingProps {
	name: string;
}

const Heading: React.FC<HeadingProps> = ({ name }) => {
	return (
		<div className="flex justify-between h-[8vh]">
			<div className="flex items-center h-full">
				<span className="page-title">
					{name}
				</span>
			</div>
			<div className="flex items-center text-fs16 text-[#858585] font-semibold leading-normal">
				<img
					className="inline mr-[5px]"
					src={SyncIcon}
					alt="sync icon"
					width="16"
					height="16"
				/>
				Last Updated - <span className="font-semibold">02/02/2025</span>
			</div>
		</div>
	);
};

export default Heading;
